<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogFormVisible"
    style="width:500px;margin:auto;"
    @close="close"
    :close-on-click-modal="false"
  >
    <el-form ref="form" :model="form" :rules="rules" v-loading="loading" :element-loading-text="elementLoadingText">
      <div class="selectSpec">
        <div class="searchtree-item" v-for="(item,i) in form.frontendPropertyInfo"  :key="i">
              <div class="searchtree-label">{{item.name}}：</div>
              <ul style="flex-wrap:wrap">
                <li v-for="(p,j) in item.propertyDetails"  :key="j" :class="(p.disable==true?'disableSpec ':'')+ (p.current==true?'on':'')"  @click="p.disable==true?selAttr1():selAttr(i,j)">
                    {{p.name}}
                </li>     
              </ul>
         </div>
         <div class="searchtree-item">
              <div class="searchtree-label-num">数量：</div>
              <ul style="flex-wrap:wrap">
                  <li class="num">
                      <span class="reduceNum no-select" @click="reduceNum">
                        -
                      </span>
                      <input type="text" v-model="num" :disabled="stockNum<=0" @change="changeNum" >
                      <span class="addNum no-select" @click="addNum">
                        +
                      </span>  
                      <span class="no-select">库存剩余({{stockNum}})</span>
                   </li>       
              </ul>
         </div>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">加入购物车</el-button>
    </div>
  </el-dialog>
</template>
<style>
@import '../../../styles/selectSpec.css';
</style>
<script>
  import {mapGetters, mapActions,mapMutations,mapState} from 'vuex'
export default {
  name: 'SelectSpec',
  components: { },
  data() {
    return {
      num:1,
      stockNum:1,
      helpFund:0.00,
      selectIndexArray:[],
      selectIdAttrray:[],
      frontendPropertyInfo:[],
      product: {},
      form: { },
      rules: { },     
      title: '',
      elementLoadingText: '数据上传中，请稍后...',     
      loading:false,
      dialogFormVisible: false,
    }
  },
  computed: {
      ...mapState(['isLogined'])
    },
  created() {},
  methods: {
    ...mapMutations(['ADD_CART', 'ADD_ANIMATION', 'SHOW_CART']),
    async showSelect(row) {
      this.title = '选择规格'       
      this.form = row 
      this.helpFund = row.helpFund   
      this.num=1;
      this.product = row;
      this.frontendPropertyInfo = this.product.frontendPropertyInfo
      if(this.form.productSpecs&&this.form.productSpecs.length==1)
      {
         this.stockNum = this.form.productSpecs[0].quantity;
      }
      else
      {
        this.stockNum=1;
      }
      this.dialogFormVisible = true
    },    
    checkAttr(){
      var productSpecs = this.form.productSpecs; //原始规格数据
      //判断是否所以规格组都选中
      var frontendPropertyInfo = this.form.frontendPropertyInfo;
      var tips = ''
      var selectAttrid = []

      for (var i = 0; i < frontendPropertyInfo.length; i++) {
        if (this.selectIndexArray.indexOf(i) < 0) {
          tips = '请选择' + frontendPropertyInfo[i].name
        }
        var propertyDetails = frontendPropertyInfo[i].propertyDetails;
        for (var j = 0; j < propertyDetails.length; j++) {
          if (propertyDetails[j].current) {
              selectAttrid.push(propertyDetails[j].id)
          }
        }
      }
      if (tips) {
        this.$message({ message: tips, type: 'error', customClass: 'c-msg' }) 
        return false
      }

      var specId = productSpecs[0].id;
      //从原始数据中找到相应规格组
      for (var i = 0; i < productSpecs.length; i++) {
        var tmp = []
        for (var y = 0; y < productSpecs[i].productPropertyInfo.length; y++) {
          tmp.push(productSpecs[i].productPropertyInfo[y].vid);
        }
        if (tmp.sort().toString() == selectAttrid.sort().toString()) {
          specId = productSpecs[i].id //规格id
          if (productSpecs[i].quantity <= 0) {
            this.$message({ message: '该规格库存不足', type: 'error', customClass: 'c-msg' }) 
            return;
          }
        }
      }
      if (specId == 0) {
        this.$message({ message: '请选择规格', type: 'error', customClass: 'c-msg' }) 
        return false
      }
      return specId 
    },
    disableSpec()
      {
        var count = this.frontendPropertyInfo.length;
        var product = this.product          
        if(count==1)
        {          
            var main = this.frontendPropertyInfo[0].propertyDetails;
            if(main&&main.length>0)
            {
               for(var m=0;m<main.length;m++)
               {
                  var sub = main[m] ;
                  var tempStockNum=0;
                  var tempselectAttrid=[];
                  tempselectAttrid.push(sub.id);

                  for (var i = 0; i < product.productSpecs.length; i++) 
                  {
                    var tmp = []
                    for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) { tmp.push(product.productSpecs[i].productPropertyInfo[y].vid);}
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = product.productSpecs[i].quantity;      
                      break;     
                    }
                  }                   
                  if(tempStockNum==0)
                  {
                     this.frontendPropertyInfo[0].propertyDetails[m].disable = true;
                  }
                  else
                  {
                     this.frontendPropertyInfo[0].propertyDetails[m].disable = false;
                  }
               }
            }         
        }      
        if(count==2)
        {       
          for(var i=0;i<this.frontendPropertyInfo.length;i++)
          {
             for(var j=0;j<this.frontendPropertyInfo[i].propertyDetails.length;j++)
             {
               this.frontendPropertyInfo[i].propertyDetails[j].disable=false;
             }
          }
          if(this.selectIndexArray.length==1)
          { 
             var main = this.frontendPropertyInfo[0].propertyDetails;
             var main1 = this.frontendPropertyInfo[1].propertyDetails;
             var exist = main.find((p) => p.id==this.selectIdAttrray[0]);
             var exist1 = main1.find((p) => p.id ==this.selectIdAttrray[0]);
             main.forEach(item=>{    
              var tempItemId  = this.selectIdAttrray[0];
              if(!exist) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                var tempItem1Id = this.selectIdAttrray[0];
                if(!exist1) {tempItem1Id = item1.id;};                 
                var tempselectAttrid=[];   
                tempselectAttrid.push(tempItemId);
                tempselectAttrid.push(tempItem1Id);

                var tempStockNum=0;
                  for (var i = 0; i < product.productSpecs.length; i++) 
                  {
                    var tmp = []
                    for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) {  tmp.push(product.productSpecs[i].productPropertyInfo[y].vid); }
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = product.productSpecs[i].quantity                  
                      break;          
                    }
                  }                   
                  if(tempStockNum==0)
                  {
                    if(exist) { item1.disable = true;   }
                    if(exist1) { item.disable = true;  }                   
                  }
                  else
                  {
                    if(exist) { item1.disable = false;  }
                    if(exist1) { item.disable = false;  }                    
                  }     
               });
             });   
          }
          if(this.selectIndexArray.length==2)          
          {            
              var main = this.frontendPropertyInfo[0].propertyDetails;
              var main1 = this.frontendPropertyInfo[1].propertyDetails;
              var existA = main.find((p) => p.id==this.selectIdAttrray[0]);
              var existA1 = main1.find((p) => p.id ==this.selectIdAttrray[0]);
              var existB = main.find((p) => p.id==this.selectIdAttrray[1]);
              var existB1 = main1.find((p) => p.id ==this.selectIdAttrray[1]);
              main.forEach(item=>{            
              var tempItemId  = this.selectIdAttrray[0];
              if(!existA) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                var tempItem1Id = this.selectIdAttrray[0];
                if(!existA1) {tempItem1Id = item1.id;};                 
                var tempselectAttrid=[];   
                tempselectAttrid.push(tempItemId);
                tempselectAttrid.push(tempItem1Id);
                var tempStockNum=0;             
                  for (var i = 0; i < product.productSpecs.length; i++) 
                  {
                    var tmp = []
                    for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) { tmp.push(product.productSpecs[i].productPropertyInfo[y].vid); }
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = product.productSpecs[i].quantity       
                      break;          
                    }
                  }                   
                  if(tempStockNum==0)
                  {
                    if(existA) { item1.disable = true;   }
                    if(existA1) { item.disable = true;  }                   
                  }
                  else
                  {
                    if(existA) { item1.disable = false;  }
                    if(existA1) { item.disable = false;  }                    
                  }     
               });
             });
             main.forEach(item=>{            
              var tempselectAttrid=[];
             var tempItemId  = this.selectIdAttrray[1];
              if(!existB) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                var tempItem1Id = this.selectIdAttrray[1];
                if(!existB1) {tempItem1Id = item1.id;};                 
                var tempselectAttrid=[];   
                tempselectAttrid.push(tempItemId);
                tempselectAttrid.push(tempItem1Id);

                var tempStockNum=0;
                  for (var i = 0; i < product.productSpecs.length; i++) 
                  {
                    var tmp = []
                    for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) { tmp.push(product.productSpecs[i].productPropertyInfo[y].vid); }
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = product.productSpecs[i].quantity;                       
                      break;          
                    }
                  }                   
                  if(tempStockNum==0)
                  {
                    if(existB) { item1.disable = true;   }
                    if(existB1) { item.disable = true;  }                   
                  }
                  else
                  {
                    if(existB) { item1.disable = false;  }
                    if(existB1) { item.disable = false;  }                    
                  }     
               });
             });
          }
        }
        if(count==3)
        {  
          for(var i=0;i<this.frontendPropertyInfo.length;i++)
          {
            for(var j=0;j<this.frontendPropertyInfo[i].propertyDetails.length;j++)
            {
              this.frontendPropertyInfo[i].propertyDetails[j].disable=false;
            }
          }
          var main = this.frontendPropertyInfo[0].propertyDetails;
          var main1 = this.frontendPropertyInfo[1].propertyDetails;
          var main2 = this.frontendPropertyInfo[2].propertyDetails;
          var productPropertys = [];
             for (var i = 0; i < product.productSpecs.length; i++) 
              {
                var tmp = []
                for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) { tmp.push(product.productSpecs[i].productPropertyInfo[y].vid); }
                if(product.productSpecs[i].quantity>0)
                {
                   productPropertys.push(tmp);
                }                
              }            
          if(this.selectIndexArray.length==1)
          {  
             var exist = main.find((p) => p.id==this.selectIdAttrray[0]);
             var exist1 = main1.find((p) => p.id ==this.selectIdAttrray[0]);
             var exist2 = main2.find((p) => p.id ==this.selectIdAttrray[0]);        
             var recordIds = [];   
             main.forEach(item=>{                  
               var tempItemId  = this.selectIdAttrray[0];
               if(exist&&item.id!=tempItemId){ return;}           
               if(!exist) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                 var tempItem1Id = this.selectIdAttrray[0];
                 if(exist1&&item1.id!=tempItem1Id){ return;}
                 if(!exist1) {tempItem1Id = item1.id;};               
                 main2.forEach(item2=>{
                  var tempItem2Id = this.selectIdAttrray[0];
                  if(exist2&&item2.id!=tempItem2Id){ return;}
                  if(!exist2) {tempItem2Id = item2.id;};                
                  var tempselectAttrid=[];
                  tempselectAttrid.push(tempItemId);
                  tempselectAttrid.push(tempItem1Id);
                  tempselectAttrid.push(tempItem2Id);

                  var tempStockNum=0;
                  for(var i=0;i<productPropertys.length;i++)
                  {
                    var tmp = productPropertys[i];
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = 1;
                      break;          
                    } 
                  }          
                 
                  if(tempStockNum==0)
                  {
                    if(recordIds.indexOf(item.id)<0)item.disable = true; 
                    if(recordIds.indexOf(item1.id)<0)item1.disable = true; 
                    if(recordIds.indexOf(item2.id)<0)item2.disable = true; 
                  }
                  else
                  {
                    if(recordIds.indexOf(tempItemId)==-1) recordIds.push(tempItemId);
                    if(recordIds.indexOf(tempItem1Id)==-1)recordIds.push(tempItem1Id);
                    if(recordIds.indexOf(tempItem2Id)==-1)recordIds.push(tempItem2Id);       
                    if(recordIds.indexOf(item.id)!=-1) item.disable=false;
                    if(recordIds.indexOf(item1.id)!=-1) item1.disable=false;
                    if(recordIds.indexOf(item2.id)!=-1) item2.disable=false;                 
                  }
                 });
               });
             });       
          }
          if(this.selectIndexArray.length==2)          
          {            
             var existA = main.find((p) => p.id==this.selectIdAttrray[0]);           
             var existB = main1.find((p) => p.id ==this.selectIdAttrray[0]);
             var existC = main2.find((p) => p.id ==this.selectIdAttrray[0]);

             var existA1 = main.find((p) => p.id==this.selectIdAttrray[1]);         
             var existB1 = main1.find((p) => p.id ==this.selectIdAttrray[1]);
             var existC1 = main2.find((p) => p.id ==this.selectIdAttrray[1]); 

             var tempId  = this.selectIdAttrray[0]; 
             var temp1Id = this.selectIdAttrray[1];             
             var recordIds = [];   
             var disRecordIds = [];
             main.forEach(item=>{                  
               var tempItemId  = tempId;
               if(existA&&item.id!=tempItemId){ return;}           
               if(!existA) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                 var tempItem1Id = tempId;
                 if(existB&&item1.id!=tempItem1Id){ return;}
                 if(!existB) {tempItem1Id = item1.id;};               
                 main2.forEach(item2=>{
                  var tempItem2Id = tempId;
                  if(existC&&item2.id!=tempItem2Id){ return;}
                  if(!existC) {tempItem2Id = item2.id;};       
                  var tempselectAttrid=[];
                  tempselectAttrid.push(tempItemId);
                  tempselectAttrid.push(tempItem1Id);
                  tempselectAttrid.push(tempItem2Id);                      
                  var tempStockNum=0;
                  for(var i=0;i<productPropertys.length;i++)
                  {
                    var tmp = productPropertys[i];
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = 1;
                      break;          
                    } 
                  }   
                 
                  if(tempStockNum==0)
                  {       
                    if(recordIds.indexOf(item.id)<0){item.disable = true; disRecordIds.push(item.id);}
                    if(recordIds.indexOf(item1.id)<0){item1.disable = true; disRecordIds.push(item1.id);}
                    if(recordIds.indexOf(item2.id)<0) {item2.disable = true; disRecordIds.push(item2.id); } 
                  }
                  else
                  {                    
                    if(recordIds.indexOf(tempItemId)==-1) recordIds.push(tempItemId);
                    if(recordIds.indexOf(tempItem1Id)==-1)recordIds.push(tempItem1Id);
                    if(recordIds.indexOf(tempItem2Id)==-1)recordIds.push(tempItem2Id);       
                    if(recordIds.indexOf(item.id)!=-1) item.disable=false;
                    if(recordIds.indexOf(item1.id)!=-1)item1.disable=false;
                    if(recordIds.indexOf(item2.id)!=-1)item2.disable=false;
                  }
                 });
               });
             });    
             for(var i=0;i<disRecordIds.length;i++)         
             {
                if(recordIds.indexOf(disRecordIds[i])!=-1)              
                {
                   disRecordIds.splice(i,1);
                   i--;
                }
             }
             var recordIds1 = [];   
             main.forEach(item=>{                  
               var tempItemId  = temp1Id;
               if(existA1&&item.id!=tempItemId){ return;}           
               if(!existA1) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                 var tempItem1Id = temp1Id;
                 if(existB1&&item1.id!=tempItem1Id){ return;}
                 if(!existB1) {tempItem1Id = item1.id;};               
                 main2.forEach(item2=>{
                  var tempItem2Id = temp1Id;
                  if(existC1&&item2.id!=tempItem2Id){ return;}
                  if(!existC1) {tempItem2Id = item2.id;};       
                  var tempselectAttrid=[];
                  tempselectAttrid.push(tempItemId);
                  tempselectAttrid.push(tempItem1Id);
                  tempselectAttrid.push(tempItem2Id);                      
                  var tempStockNum=0;
                  for(var i=0;i<productPropertys.length;i++)
                  {
                    var tmp = productPropertys[i];
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = 1;
                      break;          
                    } 
                  }                    
                  if(tempStockNum==0)
                  {       
                    if(recordIds1.indexOf(item.id)<0)item.disable = true; 
                    if(recordIds1.indexOf(item1.id)<0)item1.disable = true; 
                    if(recordIds1.indexOf(item2.id)<0)item2.disable = true;                   
                  }
                  else
                  {                    
                    if(recordIds1.indexOf(tempItemId)==-1) recordIds1.push(tempItemId);
                    if(recordIds1.indexOf(tempItem1Id)==-1)recordIds1.push(tempItem1Id);
                    if(recordIds1.indexOf(tempItem2Id)==-1)recordIds1.push(tempItem2Id);       
                    if(recordIds1.indexOf(item.id)!=-1&&disRecordIds.indexOf(item.id)==-1) item.disable=false;
                    if(recordIds1.indexOf(item1.id)!=-1&&disRecordIds.indexOf(item1.id)==-1)item1.disable=false;
                    if(recordIds1.indexOf(item2.id)!=-1&&disRecordIds.indexOf(item2.id)==-1)item2.disable=false;
                  }
                 });
               });
             });     
          }
          if(this.selectIndexArray.length==3)          
          {            
             var existA = main.find((p) => p.id==this.selectIdAttrray[0]);           
             var existB = main1.find((p) => p.id ==this.selectIdAttrray[0]);
             var existC = main2.find((p) => p.id ==this.selectIdAttrray[0]);  
             var existA1 = main.find((p) => p.id==this.selectIdAttrray[1]);         
             var existB1 = main1.find((p) => p.id ==this.selectIdAttrray[1]);
             var existC1 = main2.find((p) => p.id ==this.selectIdAttrray[1]);
             var existA2 = main.find((p) => p.id==this.selectIdAttrray[2]);         
             var existB2 = main1.find((p) => p.id ==this.selectIdAttrray[2]);
             var existC2 = main2.find((p) => p.id ==this.selectIdAttrray[2]);

             var tempId  = this.selectIdAttrray[0]; 
             var temp1Id = this.selectIdAttrray[1];     
             var temp2Id = this.selectIdAttrray[2];   
             var recordIds = [];   
             var disRecordIds = [];
             main.forEach(item=>{                  
               var tempItemId  = tempId;
               if(existA&&item.id!=tempItemId){ return;}           
               if(!existA) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                 var tempItem1Id = tempId;
                 if(existB&&item1.id!=tempItem1Id){ return;}
                 if(!existB) {tempItem1Id = item1.id;};               
                 main2.forEach(item2=>{
                  var tempItem2Id = tempId;
                  if(existC&&item2.id!=tempItem2Id){ return;}
                  if(!existC) {tempItem2Id = item2.id;};       
                  var tempselectAttrid=[];
                  tempselectAttrid.push(tempItemId);
                  tempselectAttrid.push(tempItem1Id);
                  tempselectAttrid.push(tempItem2Id);                      
                  var tempStockNum=0;
                  for(var i=0;i<productPropertys.length;i++)
                  {
                    var tmp = productPropertys[i];
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = 1;
                      break;          
                    } 
                  }   
                 
                  if(tempStockNum==0)
                  {       
                    if(recordIds.indexOf(item.id)<0){item.disable = true; disRecordIds.push(item.id);}
                    if(recordIds.indexOf(item1.id)<0){item1.disable = true; disRecordIds.push(item1.id);}
                    if(recordIds.indexOf(item2.id)<0) {item2.disable = true; disRecordIds.push(item2.id); } 
                  }
                  else
                  {                    
                    if(recordIds.indexOf(tempItemId)==-1) recordIds.push(tempItemId);
                    if(recordIds.indexOf(tempItem1Id)==-1)recordIds.push(tempItem1Id);
                    if(recordIds.indexOf(tempItem2Id)==-1)recordIds.push(tempItem2Id);       
                    if(recordIds.indexOf(item.id)!=-1) item.disable=false;
                    if(recordIds.indexOf(item1.id)!=-1)item1.disable=false;
                    if(recordIds.indexOf(item2.id)!=-1)item2.disable=false;
                  }
                 });
               });
             });      
             debugger;     
             for(var i=0;i<disRecordIds.length;i++)         
             {
                if(recordIds.indexOf(disRecordIds[i])!=-1)              
                {
                   disRecordIds.splice(i,1);
                   i--;
                }
             }
             var recordIds1 = [];   
             var disRecordIds1 = [];
             main.forEach(item=>{                  
               var tempItemId  = temp1Id;
               if(existA1&&item.id!=tempItemId){ return;}           
               if(!existA1) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                 var tempItem1Id = temp1Id;
                 if(existB1&&item1.id!=tempItem1Id){ return;}
                 if(!existB1) {tempItem1Id = item1.id;};               
                 main2.forEach(item2=>{
                  var tempItem2Id = temp1Id;
                  if(existC1&&item2.id!=tempItem2Id){ return;}
                  if(!existC1) {tempItem2Id = item2.id;};       
                  var tempselectAttrid=[];
                  tempselectAttrid.push(tempItemId);
                  tempselectAttrid.push(tempItem1Id);
                  tempselectAttrid.push(tempItem2Id);                      
                  var tempStockNum=0;
                  for(var i=0;i<productPropertys.length;i++)
                  {
                    var tmp = productPropertys[i];
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = 1;
                      break;          
                    } 
                  }                    
                  if(tempStockNum==0)
                  {       
                    if(recordIds1.indexOf(item.id)<0){item.disable = true; disRecordIds1.push(item.id);}
                    if(recordIds1.indexOf(item1.id)<0){item1.disable = true; disRecordIds1.push(item1.id);}
                    if(recordIds1.indexOf(item2.id)<0){item2.disable = true; disRecordIds1.push(item2.id);}
                  }
                  else
                  {                    
                    if(recordIds1.indexOf(tempItemId)==-1) recordIds1.push(tempItemId);
                    if(recordIds1.indexOf(tempItem1Id)==-1)recordIds1.push(tempItem1Id);
                    if(recordIds1.indexOf(tempItem2Id)==-1)recordIds1.push(tempItem2Id);       
                    if(recordIds1.indexOf(item.id)!=-1&&disRecordIds.indexOf(item.id)==-1) item.disable=false;
                    if(recordIds1.indexOf(item1.id)!=-1&&disRecordIds.indexOf(item1.id)==-1)item1.disable=false;
                    if(recordIds1.indexOf(item2.id)!=-1&&disRecordIds.indexOf(item2.id)==-1)item2.disable=false;
                  }
                 });
               });
             });  
             debugger;
             for(var i=0;i<disRecordIds1.length;i++)         
             {
                if(recordIds1.indexOf(disRecordIds1[i])!=-1)              
                {
                   disRecordIds1.splice(i,1);
                   i--;
                }
             }          
             var recordIds2 = [];   
             main.forEach(item=>{                  
               var tempItemId  = temp2Id;
               if(existA2&&item.id!=tempItemId){ return;}           
               if(!existA2) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                 var tempItem1Id = temp2Id;
                 if(existB2&&item1.id!=tempItem1Id){ return;}
                 if(!existB2) {tempItem1Id = item1.id;};               
                 main2.forEach(item2=>{
                  var tempItem2Id = temp2Id;
                  if(existC2&&item2.id!=tempItem2Id){ return;}
                  if(!existC2) {tempItem2Id = item2.id;};       
                  var tempselectAttrid=[];
                  tempselectAttrid.push(tempItemId);
                  tempselectAttrid.push(tempItem1Id);
                  tempselectAttrid.push(tempItem2Id);                      
                  var tempStockNum=0;
                  for(var i=0;i<productPropertys.length;i++)
                  {
                    var tmp = productPropertys[i];
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = 1;
                      break;          
                    } 
                  }                    
                  if(tempStockNum==0)
                  {       
                    if(recordIds2.indexOf(item.id)<0){item.disable = true; }
                    if(recordIds2.indexOf(item1.id)<0){item1.disable = true;}
                    if(recordIds2.indexOf(item2.id)<0){item2.disable = true;}
                  }
                  else
                  {                    
                    if(recordIds2.indexOf(tempItemId)==-1) recordIds2.push(tempItemId);
                    if(recordIds2.indexOf(tempItem1Id)==-1)recordIds2.push(tempItem1Id);
                    if(recordIds2.indexOf(tempItem2Id)==-1)recordIds2.push(tempItem2Id);       
                    if(recordIds2.indexOf(item.id)!=-1&&disRecordIds1.indexOf(item.id)==-1&&disRecordIds.indexOf(item.id)==-1) item.disable=false;
                    if(recordIds2.indexOf(item1.id)!=-1&&disRecordIds1.indexOf(item1.id)==-1&&disRecordIds.indexOf(item1.id)==-1)item1.disable=false;
                    if(recordIds2.indexOf(item2.id)!=-1&&disRecordIds1.indexOf(item2.id)==-1&&disRecordIds.indexOf(item2.id)==-1)item2.disable=false;
                  }
                 });
               });
             });  
             for(var i=0;i<disRecordIds1.length;i++)         
             {
                if(recordIds1.indexOf(disRecordIds1[i])!=-1)              
                {
                   disRecordIds1.splice(i,1);
                   i--;
                }
             }
          }
        }
      },
      
      setSpecDisable(count)
      {

      },
      selAttr1 ()
      {},
      selAttr (index,jj) {
        var count = this.frontendPropertyInfo[index].propertyDetails.length;
        var selectIndexArray = this.selectIndexArray
        debugger;
        for (var i = 0; i < count; i++) {
            if(i==jj)
            {
              if(this.frontendPropertyInfo[index].propertyDetails[i].current==true)
              {
                this.frontendPropertyInfo[index].propertyDetails[i].current=false;
                if (selectIndexArray.indexOf(index) >-1) {
                  var tempIndex = selectIndexArray.indexOf(index);
                  selectIndexArray.splice(tempIndex,1)
                }
              }
              else
              {
                this.frontendPropertyInfo[index].propertyDetails[i].current=true;
                if (selectIndexArray.indexOf(index) < 0) {
                  selectIndexArray.push(index)
                }
              }
            }
            else
            {
              this.frontendPropertyInfo[index].propertyDetails[i].current = false;
            }
        }      
       
        var selectAttrid = []
        selectIndexArray=[];
        for (var i = 0; i < this.frontendPropertyInfo.length; i++) {
            var propertyDetails = this.frontendPropertyInfo[i].propertyDetails;
            for (var j = 0; j < propertyDetails.length; j++) {
                if (propertyDetails[j].current) {
                    selectAttrid.push(propertyDetails[j].id)
                    if (selectIndexArray.indexOf(i) < 0) {
                    selectIndexArray.push(i)
                }
                }
            }
        }
        this.selectIdAttrray = JSON.parse(JSON.stringify(selectAttrid));
        var product = this.product

        var stockNum = this.stockNum
            //从原始数据中找到相应规格组
        for (var i = 0; i < product.productSpecs.length; i++) {
            var tmp = []
            for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) {
                tmp.push(product.productSpecs[i].productPropertyInfo[y].vid);
            }
            if (tmp.sort().toString() == selectAttrid.sort().toString()) {
                stockNum = product.productSpecs[i].quantity
            }
        }
        this.stockNum = stockNum
        if(this.num>this.stockNum)this.num=this.stockNum;
        this.selectIndexArray = selectIndexArray       
        this.disableSpec();
        this.$forceUpdate();
      },
      reduceNum()
      {
        this.num--;
        if(this.num<=0)
        {
          this.$message({ message: '数量必须大于0', type: 'error', customClass: 'c-msg' }) 
          this.num=1;
          return;
        }
      },
      addNum()
      {
        var productSpecs = this.form.productSpecs; //原始规格数据
      //判断是否所以规格组都选中
      var frontendPropertyInfo = this.form.frontendPropertyInfo;
      var tips = ''
      var selectAttrid = []

      for (var i = 0; i < frontendPropertyInfo.length; i++) {
        if (this.selectIndexArray.indexOf(i) < 0) {
          tips = '请选择' + frontendPropertyInfo[i].name
        }
        var propertyDetails = frontendPropertyInfo[i].propertyDetails;
        for (var j = 0; j < propertyDetails.length; j++) {
          if (propertyDetails[j].current) {
              selectAttrid.push(propertyDetails[j].id)
          }
        }
      }
      if (tips) {
        this.$message({ message: tips, type: 'error', customClass: 'c-msg' }) 
        return false
      }
         this.num++;
        if(this.num>this.stockNum)
        {
          this.$message({ message: '数量不可大于库存', type: 'error', customClass: 'c-msg' }) 
          this.num=this.stockNum;
          return;
        }
      },
    changeNum()
    {      
      var myreg=/^\+?[1-9]\d*$/;
        if(!myreg.test(this.num))
        {
          this.$message({ message: '数量格式不对', type: 'error', customClass: 'c-msg' }) 
          this.num=1;
          if(this.stockNum==0)this.num=0;
          return;
        }
      if(this.num==''||this.num==undefined|| parseInt(this.num)>this.stockNum)
        {
          this.$message({ message: '数量不可为空，且不得大于库存', type: 'error', customClass: 'c-msg' }) 
          this.num=1;
          if(this.stockNum==0)this.num=0;
          return;
        }
        if(parseInt(this.num)<=0)
        {
          this.$message({ message: '数量必须大于0', type: 'error', customClass: 'c-msg' }) 
          this.num=1;
          return;
        }
    },
    close() {
      this.dialogFormVisible = false
    },
    save(){
        if(!this.isLogined)
        {
          this.$router.push({ name: 'userLogin' })
          return;
        }
        if(this.num<=0)
        {
          this.$message({ message: '请输入要购买的数量', type: 'error', customClass: 'c-msg' }) 
          return;
        }
        let specId= this.checkAttr()
         if(!specId){
           return
         }
        let specName = ''
        this.form.productSpecs.forEach((item) => {
          if (item.id === specId){
            specName = item.specName
          }
        })
         
        this.addCart(this.form.id, this.form.settlementPrice, this.form.name, this.form.defaultImage, specId, specName,this.num)
      },
      addCart (id, price, name, img, specId, specName,num) {
         this.ADD_CART({
            productId: id,
            settlementPrice: price,
            name: name,
            defaultImage: img,
            num: num,
            specId: specId,
            specName:specName,
            helpFund:this.helpFund
          })
          // 加入购物车动画
          var dom = event.target
          // 获取点击的坐标
          let elLeft = dom.getBoundingClientRect().left + (dom.offsetWidth / 2)
          let elTop = dom.getBoundingClientRect().top + (dom.offsetHeight / 2)
          let imgs= "http://localhost:8888/static/images/logo.png"
          // 需要触发
          this.ADD_ANIMATION({moveShow: true, elLeft: elLeft, elTop: elTop, img: imgs})
          if (!this.showCart) {
            this.SHOW_CART({showCart: true})
          }
          this.$message({ message: '加入购物车成功', type: 'success', customClass: 'c-msg' }) 
          this.dialogFormVisible = false
      }
  },
}
</script>



// WEBPACK FOOTER //
// SelectSpec.vue?554fce85